import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import Comp from 'components/comps/row';
import EmptyState from 'shared/empty_state';
import LoadingSpinner from 'components/ui/loading_spinner';

export default function CompSelectorComps({ loading, results, selectedComps, onDeselect, onPageChange, onSelect }) {
  let content;
  if (!results) {
    content = <LoadingSpinner />;
  } else if (!results.meta.totalPages) {
    content = (
      <EmptyState
        bodyText="Try searching again or clearing your filters"
        header="No comps found"
        icon={faSearch}
      />
    );
  } else {
    content = <React.Fragment>
      <div>
        {results.comps.map(comp => (
          <Comp
            comp={comp}
            key={comp.id}
            selected={selectedComps.map(comp => comp.id).includes(comp.id)}
            onDeselect={onDeselect}
            onSelect={onSelect}
          />
        ))}
      </div>

      <div className="d-flex align-items-center mt-3">
        <UltimatePagination
          currentPage={results.meta.currentPage}
          totalPages={results.meta.totalPages}
          onChange={onPageChange}
        />
      </div>
    </React.Fragment>;
  }

  return (
    <div className={classNames('comp-selector-comps', { loading: loading && results })}>
      {content}
    </div>
  );
}

CompSelectorComps.propTypes = {
  loading: PropTypes.bool,
  results: PropTypes.shape({
    comps: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
    meta: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
    }).isRequired,
  }),
  selectedComps: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDeselect: PropTypes.func,
  onPageChange: PropTypes.func,
  onSelect: PropTypes.func,
};
